require('./style.less');

var Marionette = require('marionette'),
    Spinner = require('../../../common/spinView'),
    fvChannel = require('glRadio').channel('FV');

require('jqLoadingButton');

/*
 * unauthorizedDataModel: required -- model from FV.unauthorizedData
 * loginError: null or logInErrorMessage on auth.state if one occurred
 * */

module.exports = Marionette.ItemView.extend({
    template: require('./login.hbs'),

    initialize: function( unauthorizedDataModel, loginError ) {

        this.databases = unauthorizedDataModel.getDatabases();
        this.signupUrl = unauthorizedDataModel.getSignupUrl();
        this.forgotPasswordUrl = unauthorizedDataModel.getForgotPasswordUrl();

        this.loginError = loginError;

    },

    serializeData: function() {

        var databases = this.databases,
            nDatabases = databases.length,
            signupUrl = this.signupUrl,
            forgotPasswordUrl = this.forgotPasswordUrl,
            showSignupUrl = signupUrl && signupUrl.length > 0,
            showForgotPasswordUrl =  forgotPasswordUrl && forgotPasswordUrl.length > 0,
            loginErr = getErrorMessage.call(this);


        return {
            databases:  databases.sort(),
            isErr: loginErr && loginErr.length > 0,
            errMsg: loginErr,
            hideDatabaseSelect: nDatabases < 2, // if 1, print but hide so it's value is submitted; if none, hide (and submit will be disabled)
            disableSubmit: nDatabases < 1,
            signupUrl: signupUrl,
            forgotPasswordUrl: forgotPasswordUrl,
            showSignupUrl: showSignupUrl,
            showForgotPasswordUrl: showForgotPasswordUrl,
            showSpacerBetweenSignupAndForgotPasswordLinks: showSignupUrl && showForgotPasswordUrl
        };

        /*
        * First check if there are no databases,
        * then check if there is an authentication error sent from the server.
        * */
        function getErrorMessage() {

            if (nDatabases < 1)
                return "Can't log in: no databases available";

            var authErrorMsg = this.loginError;

            if (authErrorMsg && authErrorMsg.length > 0)
                return authErrorMsg;

            return null;
        }

    },
    /* Note: dbs must be set prior to render: fetch doesn't rely on auth */
    onRender: function() {
        this.unwrap();

        var dbs = this.databases.sort(),
            lastStoredDB = fvChannel.request('localStorage').getLastDb(),
            lastDB =  lastStoredDB && _.contains(dbs, lastStoredDB) ? lastStoredDB : dbs[0];

        this.ui.database.val(lastDB);
        this.ui.loginBtn
            .addClass('btn-focus-primary')
            .loadingButton();

    },
    onShow: function() {
        var userField = this.ui.username;
        _.delay(function() {
            userField.focus();
        }, 200);
    },
    ui: {
        username:           '#username',
        passwd:             '#passwd',
        database:           '#database',
        loginBtn:           '#loginBtn',
        spinHolder:         '.spinWrLogin',
        form:               '#loginForm',
        signUpLink:         '#signupLink',
        forgotPasswordLink: '#forgotPasswordLink'
    },
    triggers: {
        'submit @ui.form':              'submit'
    },

    //TODO: implement simple validation on client: eg only checking if either or / both empty
    onSubmit: function() {

        this.$('input').blur();
        this.spinner = new Spinner();
        this.ui.spinHolder.append( this.spinner.render().el );

        fvChannel.command('userLoggedIn', { //note; the object was wrapped in array -- for NODE?
             username: this.ui.username.val(),
             password: this.ui.passwd.val(),
             database: this.ui.database.val()
        });

    },
    onBeforeDestroy: function() {
        this.ui.loginBtn.destroy();
        this.spinner && this.spinner.destroy();
        this.$('*').remove(); //hacky attempt to fix mem leak -- something going on w/jq caching...
    },
    destroy: function() {
        Marionette.ItemView.prototype.destroy.apply(this, arguments);
        /* continuation of mem leak hack */
        this.$el = null;
        this.el = null;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/loginView/loginView.js
 ** module id = 684
 ** module chunks = 0
 **/